import { render, staticRenderFns } from "./UploadEmMassa.vue?vue&type=template&id=36f14f68&scoped=true"
import script from "./UploadEmMassa.vue?vue&type=script&lang=js"
export * from "./UploadEmMassa.vue?vue&type=script&lang=js"
import style0 from "./UploadEmMassa.vue?vue&type=style&index=0&id=36f14f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f14f68",
  null
  
)

export default component.exports